module.exports = __webpack_public_path__ + "static/media/bat.d8a281d3.mp3";